import React from "react";
import { Helmet } from "react-helmet";
import { Flex, Box } from "grid-styled";
import { LinkButton } from "./Button";
import { gql } from "apollo-boost";
import { graphql, compose } from "react-apollo";
import FranchisesList from "./FranchisesList";
import FranchisesListPlaceholder from "./FranchisesListPlaceholder";
import joinPath from "../utils/join-path";

class Franchises extends React.Component {
  renderFranchisesList = () => {
    const { match, loading, error, franchises } = this.props;

    if (loading) return <FranchisesListPlaceholder />;
    if (error) return <div>Error</div>;
    return <FranchisesList franchises={franchises} match={match} />;
  };

  render() {
    const { match } = this.props;

    return (
      <Box p={3}>
        <Helmet>
          <title>Franchises</title>
        </Helmet>
        <Flex pb={2} justify="flex-end">
          <LinkButton variant="primary" to={joinPath(match.url, `/new`)}>
            Add a franchise
          </LinkButton>
        </Flex>
        {this.renderFranchisesList()}
      </Box>
    );
  }
}

const FRANCHISES_LIST_QUERY = gql`
  query FranchisesListQuery {
    franchises {
      id
      name
      slug
      assignedInHouseTty
      corporateName
      deactivated
    }
  }
`;

const enhance = compose(
  graphql(FRANCHISES_LIST_QUERY, {
    props: ({ data: { loading, error, franchises } }) => ({
      loading,
      error,
      franchises
    })
  })
);

export default enhance(Franchises);



// WEBPACK FOOTER //
// ./src/components/Franchises.js